import React from "react";
import styles from "../style";
import { Workwithus } from "../components";
import { Careerfeatures ,Footer,CardCareer, SEO} from "../components";

const careerStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'JobPosting',
  title: 'Career Opportunities at Software India',
  description: 'Join Software India - Leading software development company. Exciting career opportunities in web development, UI/UX design, video editing, graphics design, HR, and marketing. Flexible working hours, skill building, and corporate environment.',
  hiringOrganization: {
    '@type': 'Organization',
    name: 'Software India',
    sameAs: 'https://www.softwareindia.com',
  },
  employmentType: 'FULL_TIME, INTERN',
  workHours: 'Flexible',
  jobLocation: {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'IN',
    },
  },
  benefits: 'Flexible Working Hours, Skill Building, Learning Opportunities, Networking, Corporate Environment',
  skills: 'Web Development, UI/UX Design, Video Editing, Graphics Design, HR, Marketing',
};

export default function Career() {
  return (
    <>
      <SEO
        title="Careers | Join Software India | Web Development, UI/UX, Video Editing Jobs"
        description="Build your career with Software India. Open positions for web developers, UI/UX designers, video editors, graphics designers, HR, and marketing professionals. Flexible hours, skill development, and growth opportunities in a supportive corporate environment."
        keywords="software jobs India, web developer jobs, UI UX designer jobs, video editor jobs, graphics designer jobs, HR jobs, marketing jobs, software internships, IT careers India, software development careers, remote software jobs"
        url="https://www.softwareindia.com/career"
        canonical="https://www.softwareindia.com/career"
        structuredData={careerStructuredData}
      />
    <div>
      <div className={`bg-[#00040F] ${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          <Workwithus/>
          <Careerfeatures/>
          <h2 id="cards" className="text-center text-white text-6xl font-bold mt-[7rem]">Careers</h2>
          <p className="text-center text-dimWhite text-xl font-bold">Grow with Us</p>
          <CardCareer/>
          <Footer />
        </div>
      </div>
    </div>
    </>
  );
}
